import { Link } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";

const friendLinks = [
  { label: "影视资料库", to: "/category/movie" },
  { label: "高分剧集推荐", to: "/category/tv" },
  { label: "热门榜单", to: "/category/movie?sort=hot" },
  { label: "关于我们", to: "/about" },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-background-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-clapperboard-fill text-lg"></i>
              </span>
              <span className="text-lg font-black text-background-50">{siteInfo.name}</span>
            </div>
            <p className="max-w-xs text-sm leading-relaxed text-background-200/80">
              {siteInfo.tagline} · 收录欧美电影与电视剧资料，支持多维筛选与作品详情浏览。
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              网站导航
            </h3>
            <nav className="flex flex-col gap-2">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  className="w-fit cursor-pointer text-sm text-background-200/80 hover:text-accent-300"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              友情链接
            </h3>
            <nav className="flex flex-col gap-2">
              {friendLinks.map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="w-fit cursor-pointer text-sm text-background-200/80 hover:text-accent-300"
                >
                  {link.label}
                </Link>
              ))}
            </nav>
          </div>

          <div className="flex flex-col gap-3">
            <h3 className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
              联系我们
            </h3>
            <div className="flex items-start gap-2 text-sm text-background-200/80">
              <i className="ri-mail-line mt-0.5"></i>
              <span className="break-all">{siteInfo.email}</span>
            </div>
            <div className="flex items-start gap-2 text-sm text-background-200/80">
              <i className="ri-time-line mt-0.5"></i>
              <span>{siteInfo.workingHours}</span>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-100/15 pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-background-200/70">
            © {new Date().getFullYear()} {siteInfo.name} · {siteInfo.tagline}
          </p>
          <p className="text-xs text-background-200/60">{siteInfo.icp}</p>
        </div>
      </div>
    </footer>
  );
}